<template>
    <div class="container">
        <label-modal :show.sync="showLabelModal" :booking="booking"></label-modal>
        <attach-invoice-modal :show.sync="showInvoiceModal" :booking="booking"></attach-invoice-modal>
        <div class="row">
            <heading>{{ $t('booking.showHeading') }}
                <span class="badge badge-info" v-if="booking.is_return">{{ $t('booking.returnBookingBadgeText') }}</span>
                <template v-slot:actions>
                    <b-dropdown variant="link" toggle-class="text-decoration-none p-0" v-if="booking.is_return === false || $root.isAdmin || $root.isSuperAdmin">
                        <template v-slot:button-content>
                            {{ $t('core.actions.actions') }}
                        </template>
                        <b-dropdown-item href="#" @click.prevent.stop="showLabelModal = true">
                            {{ $t('booking.sendLabel') }}
                        </b-dropdown-item>
                        <b-dropdown-item href="#" @click.prevent.stop="showInvoiceModal = true">
                            {{ $t('booking.attachInvoice') }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="booking.hasPickup" :href="'/pickup/?highlight=' + booking.pickupId">
                            {{ $t('booking.seePickup') }}
                        </b-dropdown-item>
                        <b-dropdown-item :href="`/bookings/return/${booking.id}`" @click="" v-if="booking.is_return === false">{{ $t('core.actions.bookReturnBooking') }}</b-dropdown-item>
                        <b-dropdown-item v-if="$root.isAdmin" href="#" @click.prevent="resendBooking(booking.id)">{{ $t('core.actions.resendBooking') }}</b-dropdown-item>
                        <b-dropdown-item v-if="$root.isSuperAdmin" href="#" @click.prevent="deleteBooking(booking.id)">{{ $t('core.actions.deleteBooking') }}</b-dropdown-item>
                    </b-dropdown>
                </template>
            </heading>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="card">
                    <div class="card-body">
                        <h2>{{ $t('booking.sender') }}</h2>
                        <table class="table">
                            <tr>
                                <th>{{ $t('booking.fields.referenceNumber') }}</th>
                                <td>{{ booking.reference_number }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.webOrdernumber') }}</th>
                                <td>{{ booking.orderNumber }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.name') }}</th>
                                <td>{{ booking.name }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.address') }}</th>
                                <td>{{ booking.address }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.postal_code') }}</th>
                                <td>{{ booking.postal_code }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.city') }}</th>
                                <td>{{ booking.city }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.country') }}</th>
                                <td>{{ booking.country }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.phone') }}</th>
                                <td>{{ booking.phone_prefix }} {{ booking.phone }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.send_label') }}</th>
                                <td>{{ booking.send_label ? $t('core.yes') : $t('core.no') }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.label_email') }}</th>
                                <td>{{ booking.label_email }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="card mt-5" v-if="booking.load_address.length > 0">
                    <div class="card-body">
                        <h2>{{ $t('booking.loadAddress') }}</h2>
                        <table class="table">
                            <tr>
                                <th>{{ $t('booking.fields.name') }}</th>
                                <td>{{ booking.load_address[0].name }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.address') }}</th>
                                <td>{{ booking.load_address[0].address }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.postal_code') }}</th>
                                <td>{{ booking.load_address[0].postal_code }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.city') }}</th>
                                <td>{{ booking.load_address[0].city }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.country') }}</th>
                                <td>{{ booking.load_address[0].country }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="card mt-5 mt-md-0">
                    <div class="card-body">
                        <h2>{{ $t('booking.recipient') }}</h2>
                        <table class="table">
                            <tr>
                                <th>{{ $t('booking.fields.referenceNumber') }}</th>
                                <td>{{ booking.recipient.reference_number }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.name') }}</th>
                                <td>{{ booking.recipient.name }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.address') }}</th>
                                <td>{{ booking.recipient.address }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.address2') }}</th>
                                <td>{{ booking.recipient.address2 }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.postal_code') }}</th>
                                <td>{{ booking.recipient.postal_code }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.city') }}</th>
                                <td>{{ booking.recipient.city }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.country') }}</th>
                                <td>{{ booking.recipient.country }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('recipient.fields.phone') }}</th>
                                <td>{{ booking.recipient.phone_prefix }} {{ booking.recipient.phone }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('recipient.fields.email') }}</th>
                                <td>{{ booking.recipient.email }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="card mt-5" v-if="booking.unload_address.length > 0">
                    <div class="card-body">
                        <h2>{{ $t('booking.unloadAddress') }}</h2>
                        <table class="table">
                            <tr>
                                <th>{{ $t('booking.fields.name') }}</th>
                                <td>{{ booking.unload_address[0].name }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.address') }}</th>
                                <td>{{ booking.unload_address[0].address }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.address2') }}</th>
                                <td>{{ booking.unload_address[0].address2 }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.postal_code') }}</th>
                                <td>{{ booking.unload_address[0].postal_code }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.city') }}</th>
                                <td>{{ booking.unload_address[0].city }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.country') }}</th>
                                <td>{{ booking.unload_address[0].country }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('recipient.fields.phone') }}</th>
                                <td>{{ booking.unload_address[0].phone_prefix }} {{ booking.unload_address[0].phone }}</td>
                            </tr>
                            <tr>
                                <th>{{ $t('recipient.fields.email') }}</th>
                                <td>{{ booking.unload_address[0].email }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="card mt-5">
                    <div class="card-body">
                        <h2>{{ $t('booking.goods') }}</h2>
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="border-top-0">{{ $t('booking.fields.lineDescription') }}</th>
                                <th class="border-top-0">{{ $t('booking.fields.linePackage') }}</th>
                                <th class="border-top-0">{{ $t('booking.fields.lineWeight') }}</th>
                                <th class="border-top-0">{{ $t('booking.fields.lineVolume') }}</th>
                                <th class="border-top-0">{{ $t('booking.fields.lineLoadingMeters') }}</th>
                                <th class="border-top-0" v-if="showValue">{{ $t('booking.fields.value') }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="items in booking.lines">
                                <td>{{ items.description }}</td>
                                <td>{{ items.packages }} {{ $t('booking.unitTypes.' + items.unit) }}</td>
                                <td>{{ new Intl.NumberFormat().format(items.weight/1000) }}</td>
                                <td>{{ new Intl.NumberFormat().format(items.volume/1000) }}</td>
                                <td>{{  new Intl.NumberFormat().format(items.loading_meters/1000) }}</td>
                                <td v-if="showValue">{{  new Intl.NumberFormat(language, {style: 'currency', currency: items.value_currency}).format(items.value/100) }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="card mt-5">
                    <div class="card-body">
                        <h2>{{ $t('booking.services') }}</h2>
                        <table class="table">
                            <tr>
                                <th>{{ $t('booking.deliveryForm') }}</th>
                                <td>{{ $t('additional_services.serviceLevels.' + booking.service_level)  }}<br /><br />
                                    <p v-for="service in booking.additional_services">{{ $t('additional_services.additionalServices.' + booking.service_level + '.' + service)  }}</p>
                                </td>
                            </tr>
                            <tr>
                                <th>{{ $t('booking.fields.instructions') }}</th>
                                <td>{{ booking.instruction }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="card mt-5">
                    <div class="card-body">
                        <h2>{{ $t('company.incoterm') }}</h2>
                        {{ booking.incoterm }}<small class="ml-2 text-muted">{{ $t('incoterm.terms.' + booking.incoterm) }}</small>
                    </div>
                </div>
            </div>

            <Card class="col-12" card-class="mt-5">
                <h2>{{ $t('booking.freightPayer') }}</h2>
                <table class="table">
                    <tr>
                        <td>{{ $t('booking.fields.name') }}</td>
                        <td>{{ booking.freight_payer[0].name }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('booking.fields.address') }}</td>
                        <td>{{ booking.freight_payer[0].address }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('booking.fields.country') }}</td>
                        <td>{{ booking.freight_payer[0].country }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('booking.fields.postal_code') }}</td>
                        <td>{{ booking.freight_payer[0].postal_code }}</td>
                    </tr>
                    <tr>
                        <td>{{ $t('booking.fields.city') }}</td>
                        <td>{{ booking.freight_payer[0].city }}</td>
                    </tr>
                </table>
            </Card>

            <div class="col-12" v-if="booking.delivered_by_sender && ! booking.is_return">
                <div class="card mt-5">
                    <div class="card-body">
                        <h2>{{ $t('booking.fields.deliveredBySender') }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BDropdown } from 'bootstrap-vue'
import LabelModal from '@/Components/LabelModal'
import AttachInvoiceModal from '@/Components/AttachInvoiceToBookingModal'
import Card from '@/Components/Card'
    export default {
        name: 'BookingShow',
        components: {BDropdown, LabelModal, AttachInvoiceModal, Card},
        data: () => {
            return {
                language: lgt.language,
                booking: lgt.booking,
                showLabelModal: false,
                showInvoiceModal: false
            }
        },
        computed: {
          showValue() {
            return this.booking.lines.filter(line => line.value !== null).length > 0
            }
        },
        methods: {
            resendBooking (bookingId) {
                axios.post('/bookings/' + bookingId + '/resend').then((response) => {
                    this.$saveSuccess();
                })
            },
            deleteBooking (bookingId) {
                axios.delete('/bookings/' + bookingId).then((response) => {
                    window.location = '/bookings?success'
                })
            },
        }
    }
</script>
